export default class ShowMore {

    /**
     * Toggle ShowMore content
     */
    static init() {
        const triggers = document.querySelectorAll('.jsShowMore');

        if (triggers.length > 0) {
            triggers.forEach(trigger => {
                trigger.addEventListener('click', e => {
                    e.preventDefault();
                    let target = trigger.dataset.target;
                    if (target) {
                        let targetEl = document.querySelector(target);
                        if (targetEl) {
                            targetEl.classList.toggle('open');
                            trigger.classList.toggle('open');
                            // detect if it's opened or closed
                            if (trigger.classList.contains('open')) {
                                targetEl.classList.remove('ellipsis');
                            } else {
                                // add ellipsis with delay (250 = animation time) 'cause buggy animation behaviour
                                setTimeout(() => {
                                    targetEl.classList.add('ellipsis');
                                }, 250);
                            }
                        }
                    }
                });
            });
        }
    }

    static hiddenItems() {
        const triggers = document.querySelectorAll('.jsShowHiddenItems');
        let hiddenItems;

        const showItems = parent => {

            if (parent) {
                let parentEl = document.getElementById(parent);
                if (parentEl) {
                    hiddenItems = parentEl.querySelectorAll('.js-hidden-item');
                    parentEl.classList.toggle('opened');
                }
                // console.log(parentEl, hiddenItems);
                if (hiddenItems.length > 0) {
                    hiddenItems.forEach(item => {
                        item.classList.toggle('opened');
                    });
                }
            }
        };

        if (triggers.length > 0) {
            triggers.forEach(trigger => {
                let parent = trigger.dataset.parent;
                if (window.matchMedia('(min-width:768px)').matches && trigger.dataset.mdhidden === '') {
                    trigger.classList.add('none');
                    trigger.classList.remove('inline-block');
                    showItems(parent);
                }
                trigger.addEventListener('click', e => {
                    e.preventDefault();
                    trigger.classList.toggle('link--product-grid-open');
                    trigger.classList.toggle('link--arrow-down');
                    showItems(parent);
                });
            });
        }
    }
}
